<template>
  <div id="page">
    <SogCard>
      <SogCardTitle>
        Zusammenfassung Ihrer Bestellung
        <!--
        <template #SubTitle>
          Bitte überprüfen Sie noch einmal Ihre Bestellung und klicken Sie anschließend auf "Kostenpflichtig bestellen", um &lt;!&ndash;Ihre Zahlung mit Vorkasse durchzuführen und&ndash;&gt; Ihre Bestellung abzuschließen.
        </template>
-->
      </SogCardTitle>
      <SogCardContent>
        Bitte überprüfen Sie noch einmal Ihre Bestellung und klicken Sie anschließend auf "Kostenpflichtig bestellen",
        um <!--Ihre Zahlung mit Vorkasse durchzuführen und--> Ihre Bestellung abzuschließen.
      </SogCardContent>
      <SogCardContent v-show="_invoiceVisible">
        <SogCard>
          <SogCardTitle>Rechnungsempfänger</SogCardTitle>
          <SogCardContent>
            {{ _address.fullName }}<br>
            {{ _address.line1 }}<br>
            {{ _address.street }} {{ _address.houseNumber }} {{ _address.houseNumberAddition }}<br>
            {{ _address.postalCode }} {{ _address.city }}<br>
            {{ _address.countryName }}<br>
          </SogCardContent>
        </SogCard>
      </SogCardContent>
      <SogCardContent>
        <SogCard>
          <SogCardTitle>Positionen</SogCardTitle>
          <SogCardContent>
            <SogFlexRow style="justify-content: flex-start">
              <ShoppingCartItemComponent
                v-for="item in _items"
                :key="item"
                class="sog-card-without-title"
                :item="item"
                :is-invoiced="_isInvoiced"
              />
            </SogFlexRow>
          </SogCardContent>
        </SogCard>
      </SogCardContent>
      <SogCardContent v-show="_evbVisible">
        <SogCard>
          <SogCardTitle>eVb generieren</SogCardTitle>
          <SogCardContent>
            {{ currentShoppingCart.activationPerson.Person.getFullPersonName() }}<br>
            {{ currentShoppingCart.activationPerson.Address.street }}
            {{ currentShoppingCart.activationPerson.Address.houseNumber }}
            {{ currentShoppingCart.activationPerson.Address.houseNumberAddition }}<br>
            {{ currentShoppingCart.activationPerson.Address.postalCode }}
            {{ currentShoppingCart.activationPerson.Address.city }}<br>
            {{ currentShoppingCart.activationPerson.Address.countryCode }}<br>
            {{ currentShoppingCart.activationDuration }} Tage
          </SogCardContent>
        </SogCard>
      </SogCardContent>
      <SogCardContent v-show="_items.length>0">
        <SogForm v-show="!_isBranch">
          <SogFormField>
            <SogTextBox
              v-model="_invoiceCircle"
              placeholder="Referenznummer"
            />
          </SogFormField>
        </SogForm>


        <SogCard v-show="_isInvoiced">
          <SogCardTitle>Gesamtsumme</SogCardTitle>
          <SogCardContent>
            <SogDataLabel
              :value-type="SogDataLabelValueType.Money"
              :value="_amount"
            />
          </SogCardContent>
        </SogCard>
        <SogFlexRow style="justify-content: end">
          <SogButton
            :button-style="SogButtonStyle.Success"
            @click="finish()"
          >
            Kostenpflichtig bestellen
          </SogButton>
        </SogFlexRow>
      </SogCardContent>
    </SogCard>
  </div>
</template>

<script setup lang="ts">
import {onBeforeRouteUpdate, RouteLocationNormalizedLoaded, useRoute,} from "vue-router";
import {onMounted, reactive, ref} from "vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import {SogDataLabelValueType} from "@/shared/ui/types/SogDataLabelValueType";
import {useShoppingCartStore} from "@/modules/ShoppingCart/store";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import SogFlexRow from "@/shared/ui/SogFlexRow.vue";
import SogButton from "@/shared/ui/SogButton.vue";
import Address from "@/shared/model/Address";
import copyTo from "@/shared/utils/CopyTo";
import {useNavigationStore} from "@/modules/Navigation/store";
import apiShoppingCart from "@/modules/ShoppingCart/api";
import SogCard from "@/shared/ui/SogCard.vue";
import ShoppingCartItemComponent from "@/modules/ShoppingCart/components/ShoppingCartItemComponent.vue";
import {useSpinner} from "@/shared/composables/SogSpinner";
import {computed} from "vue";
import SogForm from "@/shared/ui/SogForm.vue";
import SogFormField from "@/shared/ui/SogFormField.vue";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import {SogButtonStyle} from "@/shared/ui/types/SogButtonStyle";
import {useAccountStore} from "@/stores/accountStore";
import {storeToRefs} from "pinia";
import {IdType} from "@/shared/model/idType";
import ShoppingCartItem from "@/shared/model/shoppingCartItem";
import apiOrder from "@/modules/Order/api";
import apiInsurance from "@/modules/Insurance/api";
import apiOrganisationStructure from "@/modules/OrganisationStructure/api";
import apiFile from "@/shared/services/apiFile";
import notificationService from "@/shared/services/NotificationService";

const _navigationStore = useNavigationStore()


const _amount = ref(0)

const _items = reactive([{
  id: "",
  productType: "",
  product: "",
  count: 0,
  grossPrice: 0,
  amount: 0,
  manufacturer: "",
  item: undefined as ShoppingCartItem | undefined
}])
const _address: Address = reactive(new Address());
const _spinner = useSpinner()
const _shoppingCartStore = useShoppingCartStore();
const _invoiceCircle = ref("");

const _accountStore = useAccountStore();
const {isBranch: _isBranch} = storeToRefs(_accountStore)

const {currentShoppingCart} = storeToRefs(_shoppingCartStore)

async function init(route: RouteLocationNormalizedLoaded) {
  _spinner.hide()
  const sector = route.params.sector as string;
  if (sector === "purchase") {
    await _shoppingCartStore.initPurchase();
  }

  _items.length = 0;
  const t_array = _shoppingCartStore.getItems();
  t_array.forEach(t => _items.push({
    id: t.id,
    productType: t.insuranceTypeName,
    product: t.productDescription,
    count: t.count,
    grossPrice: t.grossPrice,
    amount: t.amount,
    manufacturer: t.manufacturerName,
    item: t
  }))

  _amount.value = _shoppingCartStore.amount();
  copyTo(currentShoppingCart.value.invoicePerson.Address, _address)
}


onMounted(async () => {
  const route = useRoute();
  await init(route);
})


onBeforeRouteUpdate(async (to) => {
  await init(to);
})


async function finished(id?: string,idType?:IdType) {
  notificationService.success("Die Bestellung wurde erfolgreich abgeschlossen.")
  _shoppingCartStore.clear()
  _spinner.hide()

  if(id && idType) {
    await _navigationStore.showObject(idType, id);
  }
  else{
    await _navigationStore.goToShoppingCart();
  }
}

async function finish() {
  _spinner.show()

  try {
    _shoppingCartStore.setInvoiceCircle(_invoiceCircle.value)
    const t_id = await apiShoppingCart.sale(currentShoppingCart.value);
    if (t_id) {
      if (currentShoppingCart.value.saveActivationPerson) {
        try {
          await apiOrganisationStructure.update(
              _accountStore.person?.id ?? "",
              currentShoppingCart.value.activationPerson.Person,
              currentShoppingCart.value.activationPerson.Address
          );
        } catch {
          // Speichern der Adresse darf den Bestellabschluss nicht blockieren
        }
      }
      if (currentShoppingCart.value.activation) {
        const t_order = await apiOrder.orderLoad(t_id);
        if (t_order?.orderItemToInsurances && t_order?.orderItemToInsurances.length > 0) {
          const t_act = await apiInsurance.InsuranceActivate(currentShoppingCart.value.activationPerson.Person, currentShoppingCart.value.activationPerson.Address, t_order.orderItemToInsurances.map(t => t.insuranceId ?? ""), currentShoppingCart.value.activationDuration)
          if (t_act.length > 0) {
            const t_id = await apiInsurance.initPdf(t_act.map(t => t.id ?? ""), true)
            if (t_id) {
              await apiFile.downloadFile(t_id)
              if(_isBranch.value){
                await finished(t_id,IdType.Pdf);
                return;
              }
            }
          }
        }
      }
      if(_isBranch.value){
        await finished(undefined,undefined);
      }
      else
        await finished(t_id,IdType.Order);
    }
  } finally {
    _spinner.hide()
  }

}

const _isInvoiced = computed(() => {
  return currentShoppingCart.value.isInvoiced
})

const _invoiceVisible = computed(() => {
  return currentShoppingCart.value.isSale
})

const _evbVisible = computed(() => {
  return currentShoppingCart.value.activation
})


</script>

<style>

</style>
